// These are mapped to user-readable values to keep URL Params clean for users
export enum CatalogSearchSort {
  NameAsc = "asc",
  NameDesc = "desc",
  PublishDateAsc = "oldest",
  PublishDateDesc = "newest",
  DownloadsAsc = "downloadsAsc",
  DownloadsDesc = "downloadsDesc",
}
